import "./Success.css";
import helpData from "./helpData.json";

const Success = () => {
  return (
    <>
      {/* HERO SECTION */}
      <div className="success-wrapper">
        <img
          src="/assets/images/success.avif"
          alt="Success"
          className="success-image"
        />

        <div className="success-overlay">
          <div className="success-content">
            <h1>
              We’re Here to Drive <br />
              <span>Your Company’s Success.</span>
            </h1>

            <p>
              VENSAP Customer Success Team – Always by Your Side
              <br />
              The VENSAP Customer Success Team is always by your side and ready
              to support you at every stage of your journey.
              <br />
              Every customer is assigned a dedicated Customer Success Manager
              who provides comprehensive support — from initial setup and
              onboarding to day-to-day operations and continuous optimization.
            </p>
          </div>
        </div>
      </div>

      {/* HOW WE ARE HELPING */}
      <section className="help-section">
        <h2 className="help-title">{helpData.title}</h2>

        <div className="help-grid">
          {/* LEFT COLUMN */}
          <div>
            {helpData.left.map((item, index) => (
              <div className="help-item" key={index}>
                {/* <span className="check">✔</span> */}
                <span className="check">&#10003;</span>

                <p>{item}</p>
              </div>
            ))}
          </div>

          {/* RIGHT COLUMN */}
          <div>
            {helpData.right.map((item, index) => (
              <div className="help-item" key={index}>
                {/* <span className="check">✔</span> */}
                <span className="check">&#10003;</span>

                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Success;
